import React from 'react';
import PropTypes from 'prop-types';
import { ReactFlow, Background, Controls } from '@xyflow/react';

export default function FlowDiagramCanvas({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  onConnectEnd,
  onNodeClick,
  onEdgeClick,
  onPaneClick,
  onNodesDelete,
  onEdgesDelete,
  onNodeDrag,
  onNodeDragStop,
  onDragOver,
  onDrop,
  defaultEdgeOptions,
  nodeTypes,
  edgeTypes,
}) {
  return (
    <div style={{ flex: 1, minHeight: 0, minWidth: 0, height: '100%' }}>
      <ReactFlow
        style={{ width: '100%', height: '100%' }}
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onConnectEnd={onConnectEnd}
        onNodeClick={onNodeClick}
        onEdgeClick={onEdgeClick}
        onPaneClick={onPaneClick}
        onNodesDelete={onNodesDelete}
        onEdgesDelete={onEdgesDelete}
        onNodeDrag={onNodeDrag}
        onNodeDragStop={onNodeDragStop}
        onDragOver={onDragOver}
        onDrop={onDrop}
        defaultEdgeOptions={defaultEdgeOptions}
        connectionRadius={40}
        nodeClickDistance={1}
        fitView
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        attributionPosition="bottom-left"
      >
        <Background />
        <Controls showInteractive={false} position="bottom-right" />
      </ReactFlow>
    </div>
  );
}

FlowDiagramCanvas.propTypes = {
  nodes: PropTypes.array.isRequired,
  edges: PropTypes.array.isRequired,
  onNodesChange: PropTypes.func.isRequired,
  onEdgesChange: PropTypes.func.isRequired,
  onConnect: PropTypes.func.isRequired,
  onConnectEnd: PropTypes.func.isRequired,
  onNodeClick: PropTypes.func.isRequired,
  onEdgeClick: PropTypes.func.isRequired,
  onPaneClick: PropTypes.func.isRequired,
  onNodesDelete: PropTypes.func.isRequired,
  onEdgesDelete: PropTypes.func.isRequired,
  onNodeDrag: PropTypes.func.isRequired,
  onNodeDragStop: PropTypes.func.isRequired,
  onDragOver: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  defaultEdgeOptions: PropTypes.object.isRequired,
  nodeTypes: PropTypes.object.isRequired,
  edgeTypes: PropTypes.object.isRequired,
};
